export type SwitchContactTarget = {
  line: (x1: number, y1: number, x2: number, y2: number) => void;
  circle: (x: number, y: number, radius: number) => void;
  text: (text: string | string[], x: number, y: number) => void;
};

/** Shared vector drawing for PDF and SVG: open contacts, label above, dimming below. */
export function drawSwitchContact(target: SwitchContactTarget, options: {
  left: number; right: number; center: number; y: number;
  label: string | string[]; dimmed?: boolean; scale?: number;
}): void {
  const { left, right, center, y, label, dimmed, scale = 1 } = options;
  const lines = Array.isArray(label) ? label.length : 1;
  target.text(label, center, y - (11 + (lines - 1) * 9) * scale);
  target.line(left, y, center - 10.5 * scale, y);
  target.circle(center - 9 * scale, y, 1.5 * scale);
  target.line(center - 7.5 * scale, y, center + 7.5 * scale, y - 5 * scale);
  target.circle(center + 9 * scale, y, 1.5 * scale);
  target.line(center + 10.5 * scale, y, right, y);
  if (dimmed) target.text("%", center, y + 10 * scale);
}
